/**
 * File: src/utils/app-socket.js
 * Layer: Shared Utility
 * Description: Owns the single authenticated Socket.IO client reused across
 * header-level realtime features.
 * Created: 2026-08-13
 */
import { io } from 'socket.io-client';

import { getDeployment } from './deployment';

const SOCKET_API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:7091/').replace(/\/$/, '');

let socketInstance = null;
let socketRetainCount = 0;

const createSocket = () =>
    io(SOCKET_API_URL, {
        withCredentials: true,
        autoConnect: false,
        auth: {
            deployment: getDeployment()
        }
    });

/**
 * Retain the shared application socket and ensure it is connected.
 * @returns {import('socket.io-client').Socket}
 */
export const retainAppSocket = () => {
    if (!socketInstance) {
        socketInstance = createSocket();
    }

    socketRetainCount += 1;

    if (!socketInstance.active) {
        socketInstance.connect();
    }

    return socketInstance;
};

/**
 * Release one consumer of the shared application socket.
 * @returns {void}
 */
export const releaseAppSocket = () => {
    socketRetainCount = Math.max(0, socketRetainCount - 1);

    if (socketRetainCount === 0 && socketInstance) {
        socketInstance.disconnect();
        socketInstance = null;
    }
};
